import {Container} from '../../components/Container';
import React, {memo} from 'react';
import {useParams} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {MediaRenderer} from '../../components/MediaRenderer';
import {ControlRenderer} from '../../components/ControlRenderer';
import {Row} from '../../components/Row';

export const PageScreen = memo(function PageScreen() {
    const params = useParams<{ id: string }>();
    const menuEntity = useSelector(state => state.control.menuList.find(i => i.id === params.id));

    return (
        <Container>
            <div className="page-wrapper">
                <Row>
                    {
                        menuEntity?.content_list?.map((content, i) => {
                            if (content.type === 'control') {
                                return (
                                    <ControlRenderer
                                        key={`control_${menuEntity.id}_${i}`}
                                        controlTypeId={content.relational_id}/>
                                );
                            } else if (content.type === 'media') {
                                return (
                                    <MediaRenderer
                                        key={`media_${menuEntity.id}_${i}`}
                                        type={content.relational_id}/>
                                );
                            }
                            return null;
                        })
                    }
                </Row>
            </div>
        </Container>
    );
});
